import React, { useState } from "react";
import styles from "../../Cadastro/Styles/CadastroQot.module.scss";
import logo from "../../../assets/logo-horiz-movimento.gif";
import { Link } from "react-router-dom";
import aluno from "../../../assets/selecionarPerfil/aluno.png";
import educador from "../../../assets/selecionarPerfil/educador.png";
import instituicao from "../../../assets/selecionarPerfil/instituicao.png";
import TRADUCAO from "../../../assets/traducao.json";


// import { AlignRight } from "../../../components/Box/Box";
// import Select from "../../../components/Select/Select";

export default function SelecionarPerfil() {
  // const [idioma, setIdioma] = useState("es");
  const [idioma] = useState("es");

  const box = {
    width: "280px",
    height: "280px",
    border: "1px solid #000",
    borderRadius: ".5em",
    overflow: "hidden",
  };

  const image = {
    maxWidth: "100%",
  };



  return (
    <>
      
      <section>
        <img src={logo} className={styles.logo} alt="logo" />
      </section>


      <section style={{ display: "flex", flexDirection: "column" }}>
        <h2>{TRADUCAO[idioma].selectRole}:</h2>

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
            flexWrap: "wrap",
            gap: "15px",
            textAlign: "center",
          }}
        >
          <Link to="aluno">
            <h1 style={{ color: "black" }}>{TRADUCAO[idioma].student}</h1>
            <div style={box}>
              <img src={aluno} alt="aluno" style={image} />
            </div>
          </Link>

          <Link to="educador">
            <h1 style={{ color: "black" }}>{TRADUCAO[idioma].educator}</h1>
            <div style={box}>
              <img src={educador} alt="educador" style={image} />
            </div>
          </Link>

          <Link to="instituicao">
            <h1 style={{ color: "black" }}>{TRADUCAO[idioma].institution}</h1>
            <div style={box}>
              <img src={instituicao} alt="instituição" style={image} />
            </div>
          </Link>
        </div>
      </section>
    </>
  );
}
